import { render, staticRenderFns } from "./BusquedaClienteF.vue?vue&type=template&id=d8e39104"
import script from "./BusquedaClienteF.vue?vue&type=script&lang=js"
export * from "./BusquedaClienteF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports